<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Doctor Bookings</h1>
          </div>
          <div class="col-sm-2">
            <!-- <router-link style="margin-right: 10px" class="btn btn-primary"
              :to="{ name: 'create-booking' }">create</router-link> -->
            <!-- <router-link class="btn btn-success" :to="{ name: 'deleted-bookings' }">Deleted
              Bookings</router-link> -->
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <h5 class="over-title margin-bottom-15">
              <!-- Basic <span class="text-bold">Data Table</span> -->
            </h5>
            <p>
              <!-- DataTables is a plug-in for the jQuery Javascript library. It is a
              highly flexible tool, based upon the foundations of progressive
              enhancement, and will add advanced interaction controls to any
              HTML table. -->
            </p>
            <div v-if="bookings.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(booking, index) in bookings" :key="index">
                  <th scope="row">{{ booking.id }}</th>
                  <td>{{ booking.name ?? 'N/A' }}</td>
                  <td>{{ booking.phone ?? 'N/A' }}</td>

                  <td>{{ booking.appointment_day_hour ?
                    booking.appointment_day_hour.doctor_service_specialty ?
                      booking.appointment_day_hour.doctor_service_specialty.doctor_name : 'N/A' : 'N/A' ?? 'N/A' }}
                  </td>
                  <td>{{ booking.price ?? 'N/A' }}</td>
                  <td>{{ booking.date ?? 'N/A' }}</td>
                  <!-- <td>
                    <div
                      v-for="(group, groupIndex) in booking.appointment_day_hour ? booking.appointment_day_hour.appointments : ''"
                      :key="groupIndex">
                      <p>{{ group.day.name_en }}</p>
                      <ul>
                        <li v-for="(hour, hourIndex) in group.hour" :key="hourIndex">
                          {{ hour.from }} - {{ hour.to }}
                        </li>
                      </ul>
                    </div>
                  </td> -->

                  <td>{{ booking.appointment_day_hour ? booking.appointment_day_hour.appointment_day.name_en : '' }}
                  </td>

                  <!-- <td>{{ booking.appointment_day_hour ? booking.appointment_day_hour.appointment_hour.from + ' - ' +
                    booking.appointment_day_hour.appointment_hour.to : '' }}</td> -->

                  <td>{{ booking.appointment_day_hour ? booking.appointment_day_hour.appointment_hour.from + ' - ' +
                    booking.appointment_day_hour.appointment_hour.to : '' }}
                  </td>


                  <td>
                    <span :class="statusClass(booking.status ? booking.status : 'unknown')">
                      {{ booking.status ? booking.status : 'Unknown' }}
                    </span>
                  </td>
                  <!-- <td> -->
                  <!-- <td>
                    <span :class="statusClass(booking.status ? booking.status.name : 'unknown')">
                      {{ booking.status ? booking.status.name : 'Unknown' }}
                    </span>
                  </td> -->

                  <td>
                    <!-- <button class="me-2 btn btn-danger" @click="deleteBooking(booking.id)">
                      Delete
                    </button> -->
                    <router-link class="badge  bg-info spacing"
                      :to="{ name: 'show-booking', params: { id: booking.id } }">
                      Booking Details
                    </router-link>
                  </td>

                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Bookings found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
// import { store } from "../../Store";

import axios from "../../Axios";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component

export default {
  name: "AllBookings",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [], // Store DataTable instance
      // statuses: [],
      bookings: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Patiant Name', key: 'name' },
        { label: 'Patiant Phone', key: 'phone' },
        { label: 'Doctor Name', key: 'appointment_day_hour.doctor_service_specialty.doctor_name' },
        { label: 'Charge', key: 'price' },
        // { label: 'Appointments', key: 'appointments' }, // This can be customized based on the format you need.
        { label: 'Date', key: 'date' },
        { label: 'Day', key: 'appointment_day_hour.appointment_day' },
        { label: 'Hour', key: 'appointment_day_hour.appointment_hour' },
        { label: 'Status', key: 'status.name' },
      ],
    };
  },

  async created() {
    this.fetchBookings();
  },

  computed: {
    filteredBookings() {
      if (!this.searchTerm) {
        return this.bookings;
      }
      const term = this.searchTerm.toLowerCase();
      return this.bookings.filter((booking) => {
        return (
          (booking.name && booking.name.toLowerCase().includes(term)) ||
          (booking.phone && booking.phone.toLowerCase().includes(term)) ||
          (booking.price && booking.price.toLowerCase().includes(term)) ||
          (booking.appointment_day_hour && booking.appointment_day_hour.doctor_service_specialty &&
            booking.appointment_day_hour.doctor_service_specialty.doctor_name.toLowerCase().includes(term)) ||
          (booking.appointment_day_hour && booking.appointment_day_hour.appointments &&
            booking.appointment_day_hour.appointments.some((group) =>
              group.day.name_en.toLowerCase().includes(term)
            ))
        );
      });
    },
  },
  //   filteredBookings() {
  //     if (!this.searchTerm) {
  //       return this.bookings;
  //     }
  //     const term = this.searchTerm.toLowerCase();
  //     return this.bookings.filter(
  //       (booking) =>
  //         booking.name.toLowerCase().includes(term)
  //     );
  //   },

  methods: {
    async fetchBookings() {
      try {

        // const params = {};
        // if (store.userRole === 'Doctor') {
        //   params.user_id = store.user ? store.user.id : null;
        // }

        // const response = await axios.get('/admin/admin/booking/all', {
        //   params: params,
        // });

        // try {
        //   const response = await axios.get('/admin/admin/doctor/all', {
        //     headers: {
        //       Authorization: `Bearer ${store.user.access_token}`,
        //     },
        //   });
        const response = await axios.get(
          `/admin/admin/booking/all`
        );
        console.log(response);
        this.bookings = response.data.data;
        console.log(" fetching bookings:", response.data.data);
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    },
    statusClass(status) {
      switch (status) {
        case 'Pending':
          return 'badge  bg-warning text-dark'; // Yellow
        case 'Confirmed':
          return 'badge  bg-primary'; // Blue
        case 'Done':
          return 'badge  bg-success'; // Green
        case 'Canceled':
          return 'badge  bg-danger'; // Red
        default:
          return 'badge  bg-secondary'; // Gray for unknown or missing
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteBooking(id) {
      console.log("delete bookings id: ", id);
      axios
        .delete(`/admin/admin/booking/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchBookings();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}


.btn {
  padding: 0.5em 1em;
  border-radius: 0.25rem;
  font-size: 0.9em;
  text-align: center;
  display: inline-block;
  min-width: 100px;
}

/* Styling for the Current Status Badge */
.badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 0.9em;
  text-transform: capitalize;
}

/* Different Badge Colors Based on Status */
.badge-pending {
  background-color: #ffc107;
  color: #fff;
}

.badge-approved {
  background-color: #28a745;
  color: #fff;
}

.badge-rejected {
  background-color: #dc3545;
  color: #fff;
}

.badge-inprogress {
  background-color: #17a2b8;
  color: #fff;
}

/* .btn-warning {
  background-color: #ffc107;
  color: #212529;
}

.btn-primary {
  background-color: #0d6efd;
  color: #fff;
}

.btn-success {
  background-color: #198754;
  color: #fff;
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
}

.btn-secondary {
  background-color: #6c757d;
  color: #fff;
} */
</style>